module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/43.74056240.png";